/**
 * 系统备忘工具类
 */
export class SystemMemoService {
  /**
   * 单例
   */
  static _instance;

  /**
   * 获取单例
   * @param vue
   */
  static getInstance (vue) {
    if (this._instance == null) {
      this._instance = new SystemMemoService(vue);
    }
    return this._instance;
  }

  //  实例属性
  vue = null;

  constructor (vue) {
    this.vue = vue;

    this.refresh = () => {
      let that = this;
      this.vue.axios.post('/admin/systemMemo/findDateAtItemList').then(resp => {
        // console.log(resp.data);
        if (resp.data && resp.data.code === 200) {
          this.vue.$store.commit('SET_SYSTEM_MEMO_LIST', resp.data.data);
        } else {
          that.vue.$message({
            type: 'error',
            message: "更新备忘列表失败。"
          })
        }
      }).catch(resp => {
        // console.log(resp);
        that.vue.$message({
          type: 'error',
          message: "更新备忘列表失败。"
        })
      });
    }
    setInterval(() => { this.refresh(); }, 15 * 60 * 1000); // 每15分钟刷新一次
  }
}



// WEBPACK FOOTER //
// ./src/system-memo-service.js